import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import TopRequestItem from "./top_report_item";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    reports: PropTypes.array,
  },
  render() {
    const reports = this.props.reports.map(function(report) {
      return <TopRequestItem report={report} key={report.id} />;
    });

    setTimeout(function() {
      $(".grid-report").masonry({
        itemSelector: ".grid-item",
      });
    }, 500);

    return reports.length > 0 ? (
      <div>
        <article className="timeline-box mt10">
          <h2 className="mt20">イベントレビュー</h2>
          <div className="grid-report">{reports}</div>
        </article>
      </div>
    ) : (
      ""
    );
  },
});
